import countryFlagJson from './countryFlag.json';
import _ from 'lodash';

export default function GetFlag(name){
    return _.find(countryFlagJson, ['name', name]) || _.find(countryFlagJson, ['alpha3', name])
}
